import { useEffect } from 'react';
import { batch, useDispatch } from 'react-redux';
import { fetchCards } from 'lib/actions';
import Container from 'components/shared/generic/container/presentational/Container';
import DataCheck from 'components/shared/generic/dataCheck/presentational/DataCheck';
import AccountOverview from './AccountOverview';
import { useLocation } from 'react-router-dom';
import { useGetAccountQuery } from 'lib/services';

const AccountOverviewContainer = () => {
    const dispatch = useDispatch();
    const jwt = localStorage.getItem('accessToken');
    const {
        data: account,
        isLoading: isAccountLoading,
        error: accountError,
        refetch: refetchAccount,
    } = useGetAccountQuery();

    const isLoading = isAccountLoading;
    const error = accountError;

    const { pathname } = useLocation();

    useEffect(() => {
        if (pathname !== '/more') {
            refetchAccount();
        }
    }, [pathname, refetchAccount, jwt]);

    useEffect(() => {
        if (!jwt) return;
        batch(() => {
            dispatch(fetchCards());
        });
    }, [jwt, dispatch]);

    return (
        <Container>
            <DataCheck data={account} isLoading={isLoading} error={error}>
                <AccountOverview account={account} />
            </DataCheck>
        </Container>
    );
};

export default AccountOverviewContainer;
